module.exports = __webpack_public_path__ + "static/media/booking.e3a1b3a7.jpg";